import { formatDateWithTimezone } from './formatDateWithTimezone';

export const formatDateUTC = (date: string | Date, formatter: 'short' | 'long' = 'short', timezone?: string) => {
  const targetTimezone = timezone || 'UTC';
  return formatDateWithTimezone(date, targetTimezone, formatter);
};